(function () {
  'use strict';

  function isOneFlavorTin(section) {
    var handle = section.getAttribute('data-product-handle') || '';
    return handle.indexOf('build-your-') !== -1 && /-1-flavor$/.test(handle);
  }

  function basePriceInCents(section) {
    var variantsJson = section.querySelector('[id^="VariantsJson-"]');
    if (!variantsJson) return null;

    try {
      var variants = JSON.parse(variantsJson.value || variantsJson.textContent || '[]');
      return variants.length && Number.isFinite(Number(variants[0].price))
        ? Number(variants[0].price)
        : null;
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    }).format(cents / 100);
  }

  function selectedSurchargeInCents(optionsContainer) {
    var surcharge = 0;

    optionsContainer.querySelectorAll('select').forEach(function (select) {
      var option = select.options[select.selectedIndex];
      if (!option || option.disabled || !option.value) return;

      var priceDifference = Number(option.getAttribute('data-price-diff') || 0);
      if (Number.isFinite(priceDifference)) surcharge += Math.round(priceDifference * 100);
    });

    return surcharge;
  }

  function initialize(section) {
    if (!isOneFlavorTin(section)) return;

    var optionsContainer = section.querySelector('#simple-bundles-io-options');
    var price = section.querySelector('[id^="ProductPrice-"]');
    var basePrice = basePriceInCents(section);

    if (!optionsContainer || !price || basePrice === null) return;
    if (optionsContainer.getAttribute('data-cc-live-price') === 'true') return;

    function updatePrice() {
      price.textContent = formatMoney(basePrice + selectedSurchargeInCents(optionsContainer));
    }

    optionsContainer.setAttribute('data-cc-live-price', 'true');
    price.setAttribute('aria-live', 'polite');
    optionsContainer.addEventListener('change', function (event) {
      if (event.target && event.target.matches('select')) updatePrice();
    });
    updatePrice();
  }

  function scan() {
    document.querySelectorAll('[data-section-type="product-template"]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
